import React from 'react';
import { cn } from '@/shadcn/lib/utils';

interface SectionContainerProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  as?: keyof JSX.IntrinsicElements;
}

const SectionContainer = React.forwardRef<HTMLElement, SectionContainerProps>(
  ({ children, className, as: Component = 'section', ...props }, ref) => (
    <Component
      ref={ref}
      className={cn(
        'space-y-4', // sensible default spacing
        className
      )}
      {...props}
    >
      {children}
    </Component>
  )
);

SectionContainer.displayName = 'SectionContainer';

export { SectionContainer };
